var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFellowship({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.25,
    height: 50,
    viewBox: "0 0 31.25 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.376,
    y1: -0.051,
    x2: 1.164,
    y2: 0.866,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fc3f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fellowship",
    transform: "translate(-709 -2208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M20.883,15.766a5.883,5.883,0,1,1,5.883-5.883,5.888,5.888,0,0,1-5.883,5.883",
    transform: "translate(697.922 2204)",
    fill: "#dca27c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M27.688,33.61v2.615H15.922L12,33.61V23.805A9.805,9.805,0,0,1,21.805,14h0c3.268,2.615,3.268,2.615,5.883,6.537Z",
    transform: "translate(697 2206.076)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M30.883,15.766a5.883,5.883,0,1,1,5.883-5.883,5.888,5.888,0,0,1-5.883,5.883",
    transform: "translate(699.562 2204)",
    fill: "#88472b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M41.61,33.61l-3.922,2.615H25.922L22,33.61V20.019A6.018,6.018,0,0,1,28.019,14h3.786a9.805,9.805,0,0,1,9.805,9.805Z",
    transform: "translate(698.64 2206.076)",
    fill: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M15,35.61l2.615-17L28.275,16,25.459,52.605H16.307Z",
    transform: "translate(697.922 2205.395)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M25,31.717l5.977-3.05,5.789,3.05-1.307,17H26.307Z",
    transform: "translate(699.562 2209.287)",
    fill: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M19,14H35.1v5.229H19Z",
    transform: "translate(698.36 2206.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M37.773,16.969l-5.927,2.862-2.273-4.709L35.5,12.26a2.616,2.616,0,0,1,3.492,1.217h0A2.615,2.615,0,0,1,37.773,16.969Z",
    transform: "translate(700.967 2205.919)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellowship);
export default __webpack_public_path__ + "static/media/fellowship.ef39dbb30f957076f37133ebcbf28882.svg";
export { ForwardRef as ReactComponent };